<template>
    <div>
        换电补能能展示
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>